// src/utils/gamificationPerks.js
// Shared perk vocabulary + small formatters for the gamification UIs
// (missions.jsx host page + incentives.jsx admin editor). One copy per repo:
// the type slugs mirror functions/gamificationConfig.js PERK_TYPES — keep in
// sync when a perk type is added (the door app carries its own display copy).

export const PERK_LABELS = {
  drinkCard: 'Drink card',
  freeEntry: 'Extra free entries',
  crossEventEntry: 'Cross-event entry',
  vipBooth: 'VIP booth'
};

export const PERK_TYPE_OPTIONS = Object.entries(PERK_LABELS).map(([value, label]) => ({ value, label }));

export function perkLabel(type, explicitLabel) {
  return explicitLabel || PERK_LABELS[type] || type || 'Perk';
}

export function money(val) {
  const n = Number(val) || 0;
  return `$${n.toFixed(n % 1 === 0 ? 0 : 2)}`;
}

// Firestore Timestamp | Date | ISO string -> epoch ms (0 when unparseable).
export function toMillis(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (value instanceof Date) return value.getTime();
  const n = Date.parse(value);
  return Number.isFinite(n) ? n : 0;
}

export function formatDay(value) {
  const ms = toMillis(value);
  return ms ? new Date(ms).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' }) : '—';
}
